import { api } from './api';
import { getReferralResellerId, clearReferralResellerId } from '../hooks/useReferralCapture';

function buildListQuery(filters = {}) {
  const qs = new URLSearchParams();
  if (filters.status) qs.set('status', filters.status);
  if (filters.statusBucket) qs.set('statusBucket', filters.statusBucket);
  if (filters.q) qs.set('q', filters.q);
  if (filters.from) qs.set('from', filters.from);
  if (filters.to) qs.set('to', filters.to);
  if (filters.page) qs.set('page', filters.page);
  if (filters.limit) qs.set('limit', filters.limit);
  const s = qs.toString();
  return s ? `?${s}` : '';
}

export const orderService = {
  create: async (orderData) => {
    // Novo shape: items: [{productVariationId, quantity}]
    // Legado (cart): items: [{productId, variationId, quantity, price, resellerPrice, commissionPercent, productName, variationName, image}]
    // Backend recomputa totais — cliente não manda preço nem total.
    const normalizedItems = (orderData.items || []).map((it) => ({
      productVariationId: it.productVariationId ?? it.variationId,
      quantity: it.quantity
    }));
    // Se o visitante chegou via ?ref=<userId>, anexa o referral pra que
    // o backend atribua a comissão ao revendedor correto no split payment.
    const referralResellerId = getReferralResellerId();
    const payload = {
      items: normalizedItems,
      shippingAddressId: orderData.shippingAddressId || null,
      shippingCost: orderData.shippingCost || 0,
      notes: orderData.notes || null,
      source: orderData.source || 'web_checkout',
      ...(referralResellerId ? { referralResellerId } : {}),
      ...(orderData.couponCode ? { couponCode: orderData.couponCode } : {}),
    };
    const result = await api.post('/api/orders', payload);
    // Limpa o referral após uso — evita re-anexar em pedidos subsequentes.
    if (referralResellerId) clearReferralResellerId();
    return result;
  },

  getAll: async (filters = {}) => {
    return api.get(`/api/orders${buildListQuery(filters)}`);
  },

  getById: async (id) => {
    return api.get(`/api/orders/${id}`);
  },

  approve: async (orderId) => {
    return api.post(`/api/orders/${orderId}/approve`, null);
  },

  reject: async (orderId, reason) => {
    return api.post(`/api/orders/${orderId}/reject`, { rejectionReason: reason });
  },

  updateStatus: async (orderId, status) => {
    return api.patch(`/api/orders/${orderId}/status`, { status });
  }
};

export default orderService;
